module.exports = __webpack_public_path__ + "img/error-light.da39805a.png";